import React, { useState, useEffect } from 'react';
import { app } from '../firebase'; // Importez votre configuration Firebase
import { getFirestore, collection, onSnapshot, query, where } from 'firebase/firestore'; 
import { isCoownership, isProvider, useUser } from '../contexts/UserContext';
import DeleteModal from '../components/modals/DeleteModal';
import AddEvent from './AddEvent';
import { TEXT_SHARE_EVENT } from '../helpers/Text';
import ShareButton from '../components/buttons/ShareButton';
import { addEventButton, archiveEvent, changeDate, displayCalendar, displayEvents } from '../calendar/CalendarFunctions';
import UpdateEvent from './UpdateEvent';
import DetailsEvent from '../events/DetailsEvent';
import { dateFromFirebaseTimestampToFrenchDate } from '../librairies/Dates';
import { rentalManagerCanMakeActionOnCoownership } from '../librairies/UsersLib';
import { isRentalManager } from '../contexts/UserContext';
import AppDisplayPreview from '../components/AppDisplayPreview';
import evenementsPreview from '../assets/images/app-display/evenements.jpeg';

const db = getFirestore(app);

const CalendarEvents = ({ selectedDate = new Date() }) => {

  const [events, setEvents] = useState([]); 
  const [loader, setLoader] = useState(true);
  const [showAddEvent, setShowAddEvent] = useState(false); 
  const [showUpdateEvent, setShowUpdateEvent] = useState(false); 
  const [showArchiveModal, setShowArchiveModal] = useState(false); 
  const [elementToArchive, setElementToArchive] = useState(null); 
  const [dateCalendar, setDateCalendar] = useState(new Date()); 
  const [dateBegining, setDateBegining] = useState(new Date()); 
  const [eventToUpdate, setEventToUpdate] = useState(null);
  const [dateEnd, setDateEnd] = useState(() => {
    const nextDay = new Date(dateBegining); // Clone `dateBegining`
    nextDay.setDate(nextDay.getDate() + 1); // Incrémente le jour de 1
    return nextDay;
  });

  const [eventsDate, setEventsDate] = useState([]);

  //contexte de l'utilisateur connecté
  const user = useUser();  

  const [selectedEvent, setSelectedEvent] = useState(null);

  useEffect(() => {
    if (selectedDate) {
      setDateCalendar(selectedDate);
      changeDate(selectedDate, setDateBegining, setDateEnd);
    }
  }, [selectedDate]);

  useEffect(() => {
    if(eventToUpdate !== null){
      setShowUpdateEvent(true); 
    }
  }, [eventToUpdate]);

  useEffect(() => {
    if(!showUpdateEvent){
      setEventToUpdate(null);
    }
  }, [showUpdateEvent]); 

  useEffect(() => {

    const queryPlanning = query(collection(db, user.user.userData.lastCoownershipLoaded.path+"/events"), 
      where('status', '==', 'accepted')); 
      
    const unsubPlanning = onSnapshot(queryPlanning, (snapshot) => {
      if(snapshot.docs.length > 0){
        setEventsDate([]); //on remet les dates à vide pour insérer toutes les dates

        for(let i=0; i < snapshot.docs.length; ++i){ //on boucle sur l'ensemble des events activés 
          if(isProvider(user.user) && snapshot.docs[i].data().idCreator.path != "users/"+user.user.user.uid){
            continue;
          }
          
          // Convertir le timestamp Firebase en date française
          const frenchDate = dateFromFirebaseTimestampToFrenchDate(snapshot.docs[i].data().dateBegining.seconds);

          setEventsDate(dates => [...dates, frenchDate]);
        }
      }else{
        setEventsDate([]); //il n'y a pas d'events
      }
    }, error => { console.log(error) });
  
    return () => {
      console.log("unsubscribe dates event");
      unsubPlanning();
    }
  }, []); 

  useEffect(() => {    
    // Approche simple : utiliser des dates ISO string
    // Créer des dates UTC en utilisant toISOString()
    const dateBeginingISO = dateBegining.toISOString();
    const dateEndISO = dateEnd.toISOString();
    
    // Créer des objets Date à partir des ISO strings
    const dateBeginingUTC = new Date(dateBeginingISO);
    const dateEndUTC = new Date(dateEndISO);
    
    const collectionRef = query(collection(db, user.user.userData.lastCoownershipLoaded.path+"/events"), 
      where('status', '==', 'accepted'),
      where('dateBegining', '>=', dateBeginingUTC),
      where('dateBegining', '<', dateEndUTC))

    const unsubscribe = onSnapshot(collectionRef, (snapshot) => {
      console.log(snapshot.docs.length)
      if(snapshot.docs.length > 0){
        
        let arr = [];

        snapshot.docs.map((event) => {

          if(isProvider(user.user) && event.data().idCreator.path != "users/"+user.user.user.uid){
            return;
          }

          //on n'affiche pas l'event s'il est destiné aux membres du CS et que le compte est un rentalManager qui ne peut pas créé de contenu sur la copropriété
          if(isRentalManager(user.user) && !rentalManagerCanMakeActionOnCoownership(user.user) && event.data().coownershipComiteeTarget && !event.data().coownerTarget && !event.data().tenantTarget){
            return;
          }

          let obj = {
            coownership: user.user.userData.lastCoownershipLoaded.path,
            id: event.id, 
            idCreator: event.data().idCreator.path,
            title: event.data().title, 
            description: event.data().description, 
            firstname: event.data().firstnameCreator,
            lastname: event.data().lastnameCreator,
            dateBegining: event.data().dateBegining.seconds,
            dateEnd: event.data().dateEnd.seconds,
            status: event.data().status,
            files: event.data().files,
            multipleDates: event.data()?.multipleDates ?? false, 
            createdByProvider: event.data().createdByProvider ?? false,
            coownershipComiteeTarget: event.data().coownershipComiteeTarget ?? undefined,
            coownerTarget: event.data().coownerTarget ?? undefined,
            tenantTarget: event.data().tenantTarget ?? undefined,
          }

          arr.push(obj);

        });
        
        setEvents(arr);
      }else{
        setEvents([]); 
      }

      setLoader(false);
    });

    return () => {
      console.log("unsubscribe events");
      unsubscribe();
    }
  }, [dateBegining]); 


  useEffect(() => {
    if(elementToArchive !== null){
      setShowArchiveModal(true); 
    }
  }, [elementToArchive]);

  useEffect(() => {
    if(showArchiveModal === false){
      setElementToArchive(null);
    }
  }, [showArchiveModal]);

  if(selectedEvent){
    return (
      <DetailsEvent event={selectedEvent} onBack={() => setSelectedEvent(null)} />
    )
  }

  return (
    <div>      
      <div className='flex gap-4 justify-end items-start'>
        {isCoownership(user.user) && (
          <ShareButton text={TEXT_SHARE_EVENT(user.user.userData.codeOwner)} designBox={false} />
        )}
        {rentalManagerCanMakeActionOnCoownership(user.user) && (
          addEventButton(dateBegining, setShowAddEvent)
        )}
        <AppDisplayPreview image={evenementsPreview} label="Aperçu des événements dans l'application" />
      </div>

      {displayCalendar(dateCalendar, setDateCalendar, setDateBegining, setDateEnd, eventsDate)}
      
      {displayEvents(user, loader, events, dateBegining, setElementToArchive, false, setEventToUpdate, setSelectedEvent)}

      {showAddEvent ? (
        <AddEvent onClose={() => setShowAddEvent(false)} date={dateBegining}/>
      ) : null }

      {showUpdateEvent ? (
        <UpdateEvent onClose={() => setShowUpdateEvent(false)} eventPath={eventToUpdate}/>
      ) : null }

      {showArchiveModal ? (
        <DeleteModal closeAction={() => setShowArchiveModal(false)} confirmAction={() => archiveEvent(elementToArchive, setShowArchiveModal)} type={"archive"}/>
      ) : null }
    </div>
  );
};

export default CalendarEvents;

